module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [{
      'main': !_vm.id
    }]
  }, [_c('module-spinner', {
    attrs: {
      "active": _vm.loading,
      "floating": true
    }
  }), _vm._v(" "), _c('div', {
    class: [{
      'group': !_vm.id,
      'dashboard': !_vm.id,
      'dashboard--full-screen': !_vm.id,
    }]
  }, [_c('module-button', {
    staticClass: "mt0 mb",
    attrs: {
      "button": "tertiary",
      "icon": "arrow-left",
      "link": _vm.request.state === 4 || _vm.isOwnProcedure ? "dashboard-requests" : "dashboard-reviews",
      "negative": true,
      "label": !_vm.isReviewer ? "Back to requests" : _vm.status === 204 || _vm.request.state !== 3 || _vm.isOwnProcedure ? "Back to Dashboard" : "Stop Reviewing"
    }
  }), _vm._v(" "), _c('h1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && _vm.status === 204),
      expression: "!loading && status === 204"
    }],
    staticClass: "h3"
  }, [_vm._v("There are currently no pending reviews")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && _vm.status === 200),
      expression: "!loading && status === 200"
    }],
    staticClass: "review"
  }, [_c('div', {
    staticClass: "review__heading"
  }, [_c('h1', {
    staticClass: "h3"
  }, [(_vm.isReviewer) ? _c('span', {
    staticClass: "fw-medium"
  }, [_vm._v("Procedure Type: ")]) : _vm._e(), _vm._v(_vm._s(_vm.reviewNomenclatureBySlugAndId("procedure", _vm.request.procedure) || "Request") + "\n            "), (!_vm.isReviewer && _vm.request.state <= 3) ? _c('span', {
    staticClass: "c-mid"
  }, [_vm._v("(Pending)")]) : _vm._e()]), _vm._v(" "), (_vm.userRole.role === 1) ? [_c('p', {
    staticClass: "p c-tertiary"
  }, [_vm._v("Performed by "), _c('span', {
    staticClass: "fw-bold"
  }, [_vm._v("Dr " + _vm._s(_vm.doctor.full_name) + " <" + _vm._s(_vm.doctor.email) + ">")]), _vm._v(" "), (_vm.procedureDate) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.procedureDate)
    }
  }) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "p c-tertiary"
  }, [_vm._v(_vm._s(_vm.stateMessage[_vm.request.state]))])] : _vm._e(), _vm._v(" "), _c('hr')], 2), _vm._v(" "), _c('div', {
    staticClass: "review__procedure-info"
  }, [_c('h5', {
    staticClass: "h5"
  }, [_vm._v("Procedure Details")]), _vm._v(" "), _c('module-detail-list', {
    attrs: {
      "items": {
        'Procedure Date': _vm.request.most_recent_procedure ? "Most recent procedure" : _vm.request.date_of_procedure,
        'Procedure Details': _vm.request.procedure_type ? _vm.procedureType[_vm.request.procedure_type] : "(Pending)",
        'Tooth Number': _vm.request.tooth_number ? _vm.request.tooth_number : "(Pending)",
        'Rubber Dam Used': typeof _vm.request.was_rubber_dam_used === 'boolean' ? _vm.request.was_rubber_dam_used === false && 'No' || 'Yes' : "(Pending)",
      }
    }
  }), _vm._v(" "), _c('hr')], 1), _vm._v(" "), _c('div', {
    class: [
      "review__xrays",
      {
        'review__xrays--reviewer': _vm.isReviewer,
      } ]
  }, [(!_vm.isReviewer) ? _c('h2', {
    staticClass: "h4"
  }, [_vm._v("Procedure X-Rays")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "review-previews"
  }, [_vm._l((_vm.files), function(category) {
    return _vm._l((category), function(file) {
      return _c('li', {
        key: file.id,
        staticClass: "review-previews__item"
      }, [_c('module-thumbnail', {
        attrs: {
          "image": (file.image || {}).thumbnail
        },
        nativeOn: {
          "click": function($event) {
            _vm.openOverlay(file.image.original)
          }
        }
      }), _vm._v(" "), _c('div', [_c('span', {
        staticClass: "h5 mb0 mt0 fwbold"
      }, [_vm._v(_vm._s(_vm.xrayTitle[file.category]))]), _vm._v(" "), _c('span', {
        staticClass: "small mt0"
      }, [_vm._v("Date: " + _vm._s(file.date))])])], 1)
    })
  }), _vm._v(" "), (!Object.keys(_vm.files).length) ? [_c('p', {
    staticClass: "p"
  }, [_vm._v("No X-Rays Provided")]), _vm._v(" "), _c('p', [_c('small', [_vm._v("Were you provided X-Rays? Click here to "), _c('module-link', {
    staticClass: "location__link fw-bold",
    attrs: {
      "link": {
        name: "request-complete",
        params: {
          id: _vm.id
        }
      }
    }
  }, [_vm._v("Upload X-Rays")])], 1)])] : _vm._e()], 2), _vm._v(" "), _c('module-modal', {
    attrs: {
      "id": "review-overlay"
    }
  }, [(_vm.overlay) ? _c('img', {
    staticClass: "review-overlay__image",
    attrs: {
      "src": _vm.overlay
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isReviewer) ? _c('div', {
    staticClass: "review-overlay__thumbnails"
  }, _vm._l((_vm.files), function(file, index) {
    return _c('module-thumbnail', {
      key: index,
      class: [{
        'is--active': _vm.overlay === (file.image || {}).original,
      } ],
      attrs: {
        "image": (file.image || {}).thumbnail
      },
      nativeOn: {
        "click": function($event) {
          _vm.overlay = file.image.original
        }
      }
    })
  })) : _vm._e()])], 1), _vm._v(" "), (_vm.review.id) ? _c('div', {
    staticClass: "review__results"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v(_vm._s(_vm.review.rating) + "/10")]), _vm._v(" "), _vm._l((_vm.reviewQuestions), function(questionContent, slug) {
    return _c('div', {
      key: slug,
      class: ("expand-" + slug)
    }, [_c('p', {
      staticClass: "p"
    }, [(_vm.isPatient) ? _c('ExpandButton', {
      class: ("expand-" + slug)
    }) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v(_vm._s(questionContent.heading))])], 1), _vm._v(" "), _c('p', {
      staticClass: "p mb"
    }, [_c('i', [_vm._v(_vm._s(_vm.reviewAnswers[_vm.review[slug]]))])]), _vm._v(" "), (_vm.isPatient) ? _c('div', {
      staticClass: "clearfix"
    }) : _vm._e(), _vm._v(" "), (_vm.isPatient) ? _c('Expander', {
      attrs: {
        "trigger-element": (".expand-" + slug)
      }
    }, [_c('ui-tooltip', {
      attrs: {
        "level": "tip",
        "close": false
      }
    }, [_c('template', {
      slot: "message"
    }, [_vm._v("\n                  " + _vm._s(questionContent.tooltip) + "\n                ")])], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.isPatient) ? _c('div', {
      staticClass: "clearfix mb",
      staticStyle: {
        "padding-bottom": "10px"
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.isPatient) ? _c('p', {
    staticClass: "p"
  }, [_c('strong', [_vm._v("Reviewed")]), (_vm.reviewer.full_name) ? [_vm._v(" by "), _c('strong', [_vm._v("a VeriTooth specialist")])] : _vm._e(), _vm._v(" on "), _c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.review.created_at)))])], 2) : _c('p', {
    staticClass: "p"
  }, [_c('strong', [_vm._v("Reviewed")]), (_vm.reviewer.full_name) ? [_vm._v(" by "), _c('strong', [_vm._v(_vm._s(_vm.reviewer.full_name))])] : _vm._e(), _vm._v(" on "), _c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.review.created_at)))])], 2), _vm._v(" "), (_vm.review.reviewer_notes && !_vm.isPatient) ? _c('p', {
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.review.reviewer_notes))]) : _vm._e(), _vm._v(" "), (_vm.successButton[_vm.userRole.role]) ? _c('module-button', _vm._b({
    attrs: {
      "button": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.nextReview()
      }
    }
  }, 'module-button', _vm.successButton[_vm.userRole.role], false)) : _vm._e()], 2) : (_vm.isReviewer && !_vm.isOwnProcedure) ? _c('div', {
    staticClass: "review__form"
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Your Review")]), _vm._v(" "), (!_vm.hideForm) ? _c('module-form', {
    attrs: {
      "form-id": "submit-review",
      "fields": _vm.fields.reviewer,
      "wide": true,
      "action": _vm.action,
      "success": _vm.success,
      "fail": _vm.fail,
      "button": "primary"
    }
  }, [_c('module-button', {
    attrs: {
      "slot": "submit-extras",
      "button": "lightest",
      "size": "m",
      "type": "button",
      "label": "Skip This Review"
    },
    nativeOn: {
      "click": function($event) {
        _vm.nextReview()
      }
    },
    slot: "submit-extras"
  })], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "small submit-details"
  }, [_vm._v("When you submit this review, it will be automatically sent to the patient and their doctor")])], 1) : _vm._e()])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49b7c249"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/dashboard/Review.vue
// module id = 346
// module chunks = 0